import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  TextField,
  Modal
} from '@mui/material';

import Layout from '../../components/layout/layout';
import SubirComunicado from '../../components/forms/Comunicados/SubirComunicado';
import { apiGet, apiPostForm } from '../../functions/api';

export default function Comunicados() {
  const auth = useSelector(state => state.authUser.access_token);
  const usuario = useSelector(state => state.authUser);

  const [show, setShow] = useState(false);
  const [files, setFiles] = useState([]);
  const [filterFiles, setFilterFiles] = useState([]);
  const [filtros, setFiltros] = useState({ name: '', date: '' });

  const prop = { pathname: '/rh/comunicados' };

  useEffect(() => {
    getInfo();
  }, []);

  const getInfo = async () => {
    try {
      const res = await apiGet('comunicado', auth);
      const archivos = res?.data?.comunicado?.map(file => ({
        id: file?.adjuntos?.[0]?.id || '',
        name: file?.nombre || '',
        date: (file?.Fecha_comunicado || '').slice(0, 10),
        url: file?.adjuntos?.[0]?.url_temporal || '',
        id_comunicado: file?.id || ''
      })) || [];
      setFiles(archivos);
      setFilterFiles(archivos);
    } catch (error) {
      console.error('Error al cargar comunicados:', error);
    }
  };

  const handleSearch = (e) => {
    const { name, value } = e.target;
    setFiltros(prev => ({ ...prev, [name]: value }));

    const result = files.filter(file =>
      (file[name] || '').toLowerCase().includes(value.toLowerCase())
    );
    setFilterFiles(name === 'date'
      ? files.filter(file => file.date === value)
      : result
    );
  };

  const resetFilter = () => {
    setFiltros({ name: '', date: '' });
    setFilterFiles(files);
  };

  const handleView = (comunicado) => {
    apiPostForm('comunicado/add', comunicado, auth);
  };

  return (
    <Layout authUser={auth} location={prop} history={{ location: prop }} active="plataforma">
      <Box sx={{ p: 4 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
          <Typography variant="h4">Comunicados</Typography>
          <Button variant="contained" color="primary" onClick={() => setShow(true)}>
            + Nuevo Comunicado
          </Button>
        </Box>

        {/* Filtros */}
        <Grid container spacing={2} sx={{ mb: 4 }}>
          <Grid item xs={12} sm={4} md={3}>
            <TextField
              label="Fecha"
              type="date"
              name="date"
              value={filtros.date}
              onChange={handleSearch}
              fullWidth
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={3}>
            <TextField
              label="Nombre"
              name="name"
              value={filtros.name}
              onChange={handleSearch}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={4} md={3}>
            <Button onClick={resetFilter} fullWidth variant="outlined" color="secondary">
              Borrar Filtros
            </Button>
          </Grid>
        </Grid>

        {/* Lista de comunicados */}
        <Grid container spacing={3}>
          {filterFiles.length > 0 ? (
            filterFiles.map((item, index) => {
              const viewData = {
                id_comunicado: item.id_comunicado,
                empleado_id: usuario.user.empleado_id
              };

              return (
                <Grid item xs={12} sm={6} md={3} key={index}>
                  <Card variant="outlined" sx={{ height: '100%' }}>
                    <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <Typography variant="h6" gutterBottom align="center">
                        {item.name}
                      </Typography>
                      <Typography variant="body2" color="text.secondary" gutterBottom>
                        {item.date}
                      </Typography>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          handleView(viewData);
                          window.open(item.url, '_blank');
                        }}
                        sx={{ mt: 2 }}
                      >
                        Ver Comunicado
                      </Button>
                    </CardContent>
                  </Card>
                </Grid>
              );
            })
          ) : (
            <Grid item xs={12}>
              <Typography align="center" color="text.secondary">
                No hay comunicados disponibles.
              </Typography>
            </Grid>
          )}
        </Grid>
      </Box>

      {/* Modal */}
      <Modal open={show} onClose={() => setShow(false)}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            width: 500,
            maxHeight: '90vh',
            overflowY: 'auto',
            borderRadius: 2
          }}
        >
          <Typography variant="h6" mb={2}>
            Subir Comunicado
          </Typography>
          <SubirComunicado getinfo={getInfo} handleClose={() => setShow(false)} />
        </Box>
      </Modal>
    </Layout>
  );
}
